<template>
  <avl-modal class="m-conf" :is-shown="isShown" :is-collapsible="false">
    <div class="m-conf__label">{{ label }}</div>

    <el-button
      class="m-conf__button"
      type="danger"
      @click.native="$store.dispatch('game/recreateGame', $route.params.id)"
    >
      Yes
    </el-button>

    <el-button class="m-conf__button" @click.native="isShown = false">
      No
    </el-button>
  </avl-modal>
</template>

<script>
  export default {
    data: () => ({
      isShown: false,
    }),
    props: {
      label: {
        type: String,
        required: true,
      },
    },
    methods: {
      show() {
        this.isShown = true;
      },
      hide() {
        this.isShown = false;
      },
    },
  };
</script>

<style scoped lang="scss">
  .m-conf {
    &__label {
      margin-bottom: 36px;
      text-align: left;
      font-size: 24px;
    }

    &__button {
      width: 72px;
      margin: 0 12px;
    }
  }
</style>
